import { Title } from '@efast_public/fjd-component-library';
import React from 'react';
import {
  isNodeEmpty,
  PresentationNode
} from '../../api/models/Case/PresentationModel';
import { AntragNodeV2 } from './AntragNodeV2';

interface AntragPageV2Props {
  node: PresentationNode;
  hideEmpty?: boolean;
}

export function AntragPageV2({
  node,
  hideEmpty
}: AntragPageV2Props) {
  if (hideEmpty && isNodeEmpty(node)) {
    return null;
  }

  if (node.nodeType !== 'group') {
    return (
      <div>
        <AntragNodeV2 node={node} depthLevel={1} hideEmpty={hideEmpty} />
      </div>
    );
  }

  return (
    <div>
      <Title level={3}>{node.label}</Title>
      <div>
        {Object.entries(node.children).map(([key, childNode]) => {
          if (hideEmpty && isNodeEmpty(childNode)) {
            return null;
          }
          return (
            <AntragNodeV2
              key={key}
              node={childNode}
              depthLevel={2}
              hideEmpty={hideEmpty}
            />
          );
        })}
      </div>
    </div>
  );
}
